function chunkString(str: string, length: number) {
    return str.match(new RegExp('.{1,' + length + '}', 'g'));
}

function formatInputPrice(price?: undefined | number | string): string {
    if (price) {

        let newPrice: any = String(price).replace(',','.').replace(/[^0-9.\-]/g, '').split('.');
        newPrice = (newPrice.length > 2) ? `${newPrice[0]}.${newPrice.splice(0, 1)}` : newPrice.join('.');
        return newPrice.replace(/^0+/, '');
    } else {
        return '0';
    }
}

export {
    chunkString,
    formatInputPrice
}
